import { FsPickem } from "db/model/pickem/FsPickem";
import { Pickem } from "model/Pickem/Pickem";

export const mapPickem = (fsModel: FsPickem): Pickem | undefined => {
  if (!fsModel.picks) {
    return undefined;
  }

  return {
    picks: fsModel.picks,
    driverPicks: fsModel.driverPicks,
  };
};
